import {Box, makeStyles, Typography} from "@material-ui/core";
import {fontUnit} from "../../../utils/DeviceManager";
// @ts-ignore
import {useSelector} from "react-redux";
import {RootState} from "../../../store";
import { AcnColorTheme } from "../../../assets/css/AcnColorTheme";
import { ProductCard } from "../../../common/productCard/ProductCard";
import { currencyFormat } from "../../../utils/CurrencyManager";
// import iconCar from '../../../assets/img/payment_car.png';
// import iconCard from '../../../assets/img/credit_card_blue.png';
// import iconBike from '../../../assets/img/account_bike.png';
// import iconTruck from '../../../assets/img/account_truck.png';
// import iconFlower from '../../../assets/img/account_flower.png';
// import iconLand from '../../../assets/img/account_terrain.png';
// import iconInsurance from '../../../assets/img/account_insurance.png';

export function HeadCard({loanGroup, accountTypeName, registeredNumber}: any) {
    const classes = useStyles();
    const [screen, billInfo] = useSelector((state: RootState) => [
        state.deviceReducer.screenView,
        state.billerReducer.billInfo
    ]);

    // const dynamicFont = (num: number) => {
    //     const lng = amount.length
    //     if (lng <= 7) return num
    //     const lvl = (defaultWidth * 0.5) / (lng * 0.5);
    //     if (lvl >= num) return num;
    //     return lvl;
    // }

    // const dynamicTitleFont = (size: number) => {
    //     const accLng = accountTypeName.length + registeredNumber.length
    //     if (accLng <= 25) return size;
    //     if(iOS){
    //         const dynamicSize = (window.innerWidth / accLng) * 1.12;
    //         if (dynamicSize >= size){
    //             return size;
    //         }
    //         return dynamicSize;
    //     }
    //     const dynamicSize = (window.innerWidth / accLng) * 1.4;
    //     if (dynamicSize >= size) return size;
    //     return dynamicSize;
    // }

    const rowData = (fieldName: string, data: string, isRed: string) => {
        return (
        <div className={classes.content}>
            <Typography className={classes.detailTitle}>{fieldName}</Typography>
            <Typography style={{color: isRed==='true'? AcnColorTheme.secondaryRed : AcnColorTheme.black}}>
                {data}
            </Typography>
        </div>
        )
    }

    return (
        <div className={classes.card}>
            <ProductCard 
                loanGroup={loanGroup}
                accountName={accountTypeName} 
                accountNo={registeredNumber}
            />
            <div style={{
                fontSize: fontUnit(16), 
                fontWeight: 'normal',
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {rowData("กำหนดชำระ", billInfo.paymentDate, billInfo.overDueStatus)}

                { billInfo.passdueDay? 
                    rowData("ค้างชำระ", billInfo.passdueDay, billInfo.overDueStatus)
                    : <div />
                }

                { billInfo.paymentTerm?
                 rowData("งวดที่", billInfo.paymentTerm, 'false')
                 : <div /> 
                }
            
                { parseFloat(billInfo.chargeAmount) > 0 ? 
                    rowData("ค่าปรับ", billInfo.chargeAmount, 'false')
                    : <div />
                }

                <div className={classes.content}>
                    <Typography className={classes.detailTitle}>ยอดชำระ</Typography>
                    <Typography className={classes.payAmount}>
                        {currencyFormat(billInfo.billAmount)}
                    </Typography>
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    card: {
        alignItems: 'flex-start',
    },
    content: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        paddingBottom: 4
    },
    icon: {
        height: '100%',
        verticalAlign: 'middle',
        marginRight: 10
    },
    payAmount: {
        fontSize: fontUnit(24),
        fontWeight: 600,
        color: AcnColorTheme.darkBlue,
    },
    accountContainer: {
        display: 'flex',
        width: '100%',
        height: '44px',
        paddingBottom: 16,
    },
    accountDetail: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        fontSize: fontUnit(16),
    },
    accountName: {
        fontSize: fontUnit(16),
        fontWeight: 600,
    },
    detailTitle: {
        color: AcnColorTheme.darkGrey
    },
}, {name: 'TotalCard'})